module.exports = __webpack_public_path__ + "img/australia-leukaemia-male.4f0ec0ee.png";